import { Box, Fade, Grid2 } from '@mui/material';
import PriceGroupTabCard from '../PriceGroupTabCard';
import { PaginationControlled } from '@utriper/core-ui';
import { usePriceGroupTab } from 'core/contexts/priceGroupTab';

const PriceGroupTabCards = () => {
    const { handlePage, loading, priceGroupTabs, totalPriceGroupTabs, MAX_PAGE, pagePgTab } = usePriceGroupTab();

    return (
        <Fade in={!loading} timeout={300}>
            <Box component="section" display="flex" flexDirection="column" mt="16px" gap="16px">
                <Grid2 container size={12} spacing={2}>
                    {priceGroupTabs.map(({ id, name, priceGroupCount, status }) => (
                        <PriceGroupTabCard key={id} id={id} name={name} priceGroupCount={priceGroupCount} status={status} />
                    ))}
                </Grid2>
                {totalPriceGroupTabs / MAX_PAGE > 1 && <PaginationControlled count={Math.ceil(totalPriceGroupTabs / MAX_PAGE)} page={pagePgTab} onChange={handlePage} totalItems={totalPriceGroupTabs} itemsPerPage={MAX_PAGE} />}
            </Box>
        </Fade>
    );
};

export default PriceGroupTabCards;
